
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/obsluga/cookies",
      function () {
        return require("private-next-pages/obsluga/cookies.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/obsluga/cookies"])
      });
    }
  